import qs from 'qs';

export const hasLocationChanged = (nextLocation, prevLocation) => {
    const next = nextLocation || {};
    const prev = prevLocation || {};
    return (
        prev.pathname !== next.pathname ||
        prev.search !== next.search ||
        (prev.params || {}).query !== (next.params || {}).query
    );
};

export const extractExtraParams = location => {
    const parsedSearch = qs.parse(location?.search, {
        plainObjects: true,
        ignoreQueryPrefix: true,
    });
    return {
        model_id: parsedSearch.model_id,
        q: parsedSearch.q,
    };
};
